<template>
  <div>
    <div class="card card-custom gutter-b" style="box-shadow: none">
      <div class="card-header card-header-tabs-line">
        <ul
          class="nav nav-dark nav-bold nav-tabs nav-tabs-line"
          role="tablist"
          ref="builder-tab"
        >
          <li class="nav-item">
            <a
              class="nav-link active"
              data-tab="0"
              data-toggle="tab"
              href="#"
              role="tab"
            >
              Cadastro
            </a>
          </li>
        </ul>
      </div>

      <b-form class="form" @submit.stop.prevent="onSubmit">
        <div class="card-body">
          <b-tabs class="hide-tabs" v-model="tabIndex">
            <b-tab active>
              <b-row>
                <b-col md="8">
                  <b-form-group
                    :class="{ 'required-field': !form.nome }"
                    id="nome"
                    label-for="nome"
                    label="Nome"
                  >
                    <b-form-input
                      v-model="$v.form.nome.$model"
                      :state="validateState('nome')"
                      maxlength="100"
                      autofocus
                    />
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group id="ativo" label-for="ativo" label="Ativo">
                    <span class="switch switch-icon">
                      <label>
                        <input
                          type="checkbox"
                          :checked="form.ativo == true"
                          @change="setAtivo"
                        />
                        <span></span>
                      </label>
                    </span>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group
                    id="descricao"
                    label-for="descricao"
                    label="Descrição"
                  >
                    <b-form-textarea
                      v-model="form.descricao"
                      rows="3"
                      max-rows="6"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </div>

        <div class="card-footer">
          <div class="row">
            <div class="col-lg-12" style="text-align: center">
              <button
                type="submit"
                ref="submit_ambiente"
                class="btn btn-primary font-weight-bold"
              >
                Salvar
              </button>
              <router-link
                class="btn btn-clean font-weight-bold"
                :to="{ name: 'restauranteAmbientes' }"
              >
                Cancelar
              </router-link>
            </div>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { mapGetters } from "vuex";
import AmbienteData, { AmbienteDataRequired } from "./AmbienteData";

export default {
  name: "app-restaurante-ambiente-form",
  props: {
    url: {
      type: String,
      required: true,
    },
    ambiente: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [validationMixin],
  data() {
    return {
      tabIndex: 0,
      form: new AmbienteData({}),
    };
  },
  validations: {
    form: AmbienteDataRequired,
  },
  watch: {
    ambiente: {
      handler(newValue) {
        this.form = new AmbienteData(newValue || {});
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
  methods: {
    setAtivo() {
      this.form.ativo = this.form.ativo == true ? false : true;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    setSubmitLoading(isLoading) {
      const submitButton = this.$refs["submit_ambiente"];

      if (!submitButton) {
        return;
      }

      if (isLoading) {
        submitButton.classList.add("spinner", "spinner-light", "spinner-right");
        submitButton.setAttribute("disabled", "");
        return;
      }

      submitButton.classList.remove(
        "spinner",
        "spinner-light",
        "spinner-right"
      );
      submitButton.removeAttribute("disabled", "");
    },
    async onSubmit() {
      try {
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          this.$toast.error(
            "Verifique todos os campos obrigatórios do formulário!"
          );
          return;
        }

        this.setSubmitLoading(true);
        await this.$http.post(this.url, { ...this.form });
        this.$router.push({ name: "restauranteAmbientes" });
      } catch (error) {
        this.setSubmitLoading(false);
      }
    },
  },
};
</script>
